import { createFileRoute } from "@tanstack/react-router";
import { PortalTicketsPage } from "@/features/portalmessages/PortalTicketsPage";
import { portalTicketsSearch } from "@/features/portalmessages/route-params";

/** P107 Portal tickets: the client's tickets and their replies (docs/frontend/PAGES.md). */
export const Route = createFileRoute("/portal/tickets")({
  validateSearch: portalTicketsSearch,
  component: Page,
});

function Page() {
  return <PortalTicketsPage search={Route.useSearch()} />;
}
